import { ChangeDetectionStrategy, Component, effect, inject, input, output, signal, viewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInput, MatInputModule } from '@angular/material/input';
import { Store } from '@ngrx/store';
import { NavigationDirection } from '@src/suite/common/enums/navigation-direction';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';

@Component({
    selector: 'st-grid-search',
    imports: [FormsModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule],
    templateUrl: './grid-search.html',
    styleUrl: './grid-search.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-grid-search',
    },
})
export class GridSearchComponent {
    // injectables
    store = inject(Store);

    // viewChildren
    readonly searchInput = viewChild(MatInput);

    // selectors
    languageSettings = this.store.selectSignal(selectI18N);

    // signals
    readonly searchTerm = signal('');

    // inputs
    readonly isSearchActive = input<boolean>(false);

    // ouputs
    readonly searchTermChanged = output<{ searchText: string }>();
    readonly nextMatch = output<void>();
    readonly navigate = output<{ direction: NavigationDirection }>();
    readonly executeSearch = output<void>();

    constructor() {
        effect(() => {
            if (this.isSearchActive()) {
                this.searchInput()?.focus();
            }
        });
    }

    searchChanged() {
        this.searchTermChanged.emit({ searchText: this.searchTerm() });
    }

    navigateToNextMatch() {
        this.navigate.emit({ direction: NavigationDirection.NEXT });
        this.searchInput()?.focus();
    }

    navigateToPreviousMatch() {
        this.navigate.emit({ direction: NavigationDirection.PREVIOUS });
        this.searchInput()?.focus();
    }
}
